import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { MiniCartEvents } from '../../constants';

export function loadMiniCartIfNotLoaded(
  context: EcomPlatformViewerScriptContext,
): Promise<void> {
  if (context.tinyCartParams) {
    const params = context.tinyCartParams;
    context.tinyCartParams = undefined;
    let resolve!: () => void;
    const waitToFinishPreload = new Promise<void>((r) => (resolve = r));
    context.siteStore.pubSub.subscribe(
      MiniCartEvents.OnInitialData,
      () => resolve(),
      false,
    );
    void context.siteStore.windowApis.openPersistentPopup(...params);
    return waitToFinishPreload;
  }

  return Promise.resolve();
}
